import {
  changeDriverState,
  checkDriver,
  deleteDriver,
  getDriverDetail,
  getDriverImportRes,
  getDriverList,
  getInstitutionOperator,
  getJobLevel,
  matchingOperator,
  saveDriver,
  saveDriverImportRes,
  tempDownload,
} from '../services/index';

export default {
  namespace: 'driverManage',
  state: {},
  effects: {
    /**
     * 司机管理-获取业务人员列表接口
     */
    *getDriverList({ payload }, { call }) {
      return yield call(getDriverList, payload);
    },
    /**
     * 浙里报人员数据下拉
     */
    *getInstitutionOperator({ payload }, { call }) {
      return yield call(getInstitutionOperator, payload);
    },
    /**
     * 获取职级下拉枚举
     */
    *getJobLevel({ payload }, { call }) {
      return yield call(getJobLevel, payload);
    },
    /**
     * 修改司机状态（启用/停用）
     */
    *changeDriverState({ payload }, { call }) {
      return yield call(changeDriverState, payload);
    },
    /**
     * 获取司机详情
     */
    *getDriverDetail({ payload }, { call }) {
      return yield call(getDriverDetail, payload);
    },
    /**
     * 删除司机
     */
    *deleteDriver({ payload }, { call }) {
      return yield call(deleteDriver, payload);
    },
    /**
     * 保存司机
     */
    *saveDriver({ payload }, { call }) {
      return yield call(saveDriver, payload);
    },
    /**
     * 保存司机
     */
    *matchingOperator({ payload }, { call }) {
      return yield call(matchingOperator, payload);
    },
    /**
     * 获取解析结果
     */
    *getDriverImportRes({ payload }, { call }) {
      return yield call(getDriverImportRes, payload);
    },
    /**
     * 下载模板
     */
    *tempDownload({ payload }, { call }) {
      return yield call(tempDownload, payload);
    },
    /**
     * 导入解析结果
     */
    *saveDriverImportRes({ payload }, { call }) {
      return yield call(saveDriverImportRes, payload);
    },
    /**
     * 导入解析结果
     */
    *checkDriver({ payload }, { call }) {
      return yield call(checkDriver, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
